export const packageLoading =  ({store})  => store.packageReducer.loading;

export const packageError =  ({store})  => store.packageReducer.error;

export const packageData =  ({store})  => store.packageReducer.data;